import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

// get or set Optimizely user UUID from cookie, which is shared with other CustomInk apps
// see NDX: https://github.com/customink/ndx/blob/ba645961da9254db848d4a4a2822d921fd2770be/src/vendor/optimizely.js#L59
export const getOrSetOptimizelyEndUserId = () => {
    let optimizelyEndUserId = Cookies.get('optimizelyEndUserId');
    if (!optimizelyEndUserId) {
        optimizelyEndUserId = uuidv4();
        Cookies.set('optimizelyEndUserId', optimizelyEndUserId, {
            domain: import.meta.env.MODE === 'development' ? '.localhost' : '.customink.com',
            expires: 365,
        });
    }
    return optimizelyEndUserId;
};
